module.exports = __webpack_public_path__ + "static/media/enterprise.a57ee3e2.jpg";